export default __webpack_public_path__ + "static/media/login-visual1.b493afcd.jpg";